import { isNil } from 'lodash';

export const checkIsValidObject = (data) => {
  return typeof data === 'object' && !Array.isArray(data) && !isNil(data);
};
    